<template>
  <v-app id = "inspire">
    <v-main>
      <v-container
        class = "fill-height"
        fluid
      >
      <v-row
          align   = "center"
          justify = "center"
        >
          <v-col
            cols = "12"
            sm   = "8"
            md   = "4"
          >
          <div 
            v-if = "this.$vuetify.theme.dark">
            <v-card pdb20 
              :color      = "$logos.color_login_n"
              :elevation  = "0"
            > 
              <v-img 
                :src  = "$logos.login_night" 
                width = "100%"
                id    = "login_night"
              ></v-img> 
             </v-card>
          </div>
          <div 
            v-else
          >
            <v-card pdb20 
              :color      = "$logos.color_login"
              :elevation  = "0"

            > 
              <v-img 
                :src  = "$logos.login" 
                width = "100%"
                id    = "login"
              ></v-img> 
            </v-card>
          </div>

        <!-- </v-col>
      </v-row>

        <v-row
          align   = "center"
          justify = "center"
        >
          <v-col
            cols = "12"
            sm   = "8"
            md   = "4"
          > -->
            <v-card 
              class = "mt-10"
              elevation = "12"

            >  <!-- light-blue darken-4 -->
              <v-toolbar
                dark
                flat
                color = "#2c5675"
              >
                <v-toolbar-title 
                  v-text = "$ml.get('login')"
                ></v-toolbar-title>
                <v-spacer />
                </v-toolbar>
                  <v-form 
                    name            = "form" 
                    @submit.prevent = "handleLogin"
                  >
                <v-card-text class = " pb-0">
                  <!--  <v-text-field v-model="user.username"
                    v-validate="'required'"
                    label="Username"
                    name="user"
                    prepend-icon="mdi-account"
                    type="text"
                  />
                  <div
            v-if="errors.has('username')"
            class="alert alert-danger"
            role="alert"
          >Username is required!</div> -->
          
                  <v-text-field 
                    outlined
                    v-model      = "user.email"
                    :label       = "$ml.get('email')"
                    name         = "email"
                    type         = "text"
                    @click       = "keyboard_is_active('email')"
                    prepend-inner-icon = "mdi-email"
                    class         = "pa-0"
                  />
                    <!-- v-validate="'required'" -->

                  <v-text-field
                    outlined
                    v-model       = "user.password"
                    id            = "password"
                    :label        = "$ml.get('password')"
                    name          = "password"
                    prepend-inner-icon  = "mdi-lock"
                    class         = "pa-0"
                    type          = "password"
                    @click        = "keyboard_is_active('password')"

                  />
                  <!-- v-validate="'required'" -->
                  <div
                    class  = "alert alert-danger"
                    role   = "alert"
                    v-text = "$ml.get('psw_req')"
                    v-show = "!user.password"
                  ></div>
                    <!-- v-if="errors.has('password')" -->
                <v-btn 
                  small 
                  text 
                  @click = "dialog = true" 
                  v-show = "true"
                >
                  {{$ml.get('forgot_psw')}}
                </v-btn>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-chip 
                  v-show = "message"                   
                  color  = "error"
                  class  = "mx-1"
                >
                  {{ message }}
                </v-chip>
                <v-btn 
                  color  = "primary" 
                  type   = "submit" 
                  v-text = "$ml.get('login')"
                ></v-btn>
                <!-- #2c5675 -->
              </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
        <input 
          dark
          type    = "" 
          name    = ""
          @input  = "onInputChange"
          :value  = "input"
          class   = "input"
          v-show  = "false"
        >
          <!--  -->
          <v-bottom-sheet 
            inset 
            dark
            v-model = "sheet" 
          >
          <v-sheet 
            height = "300px" 
            class  = "pa-1"
          >
            <SimpleKeyboard 
              @onChange   = "onChange" 
              @onKeyPress = "onKeyPress" 
              :input      = "input" 
              :theme      = "theme"
            />
          </v-sheet>
        </v-bottom-sheet>  
        <v-dialog 
          v-model = "dialog" 
          width   = "500"
        >
          <v-card outlined>
            <v-card-title 
              v-text = "$ml.get('forgot_psw')" 
              class  = "justify-center pa-1 body-2 primary"
            ></v-card-title>
            <v-divider></v-divider>
            <v-card-text
              class = "pa-2"
            >
              <v-text-field 
                dense
                outlined
                hide-details
                v-model = "email" 
                type    = "email" 
                :label  = "$ml.get('email')" 
              ></v-text-field>
              <router-link 
                to = "/security_psw"
              >
                {{ $ml.get('recovery_process') }}
                <v-icon
                  x-small
                  color = "primary"
                >
                  mdi-arrow-right
                </v-icon>
              </router-link>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>              
              <v-spacer></v-spacer>
              <v-btn 
                small 
                color  = "primary" 
                @click = "forgot" 
                v-text = "$ml.get('confirm')" 
                v-show = "!loading"
              ></v-btn>
              <v-progress-circular 
                indeterminate 
                color   = "primary" 
                v-show  = "loading"
                class   = "mx-1"
              ></v-progress-circular>
              <v-btn 
                small 
                color  = "error" 
                @click = "dialog = false" 
                v-text = "$ml.get('close')"
              ></v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
       <v-snackbar
        top 
        right
        v-model  = "snackbar"
        :color   = "color"
        :timeout = "3000"
        >
         {{info}}
          <v-btn 
            small 
            @click = "snackbar = false"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
       </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import User           from '@/models/user';
import axios          from 'axios';
import SimpleKeyboard from "@/components/simple_Keyboard.vue";
import EventBus       from '@/event-bus';

export default {
  name: 'Login',
  components: {
    SimpleKeyboard
  },
  props: {
    source: String
  },
  data(){
    return {
      user: new User('',''),
      loading:false,
      message:'',
      mode: true, 
      dialog: false,
      email:'',
      snackbar: false,
      color: '',
      info: '',
      input: '',
      theme: 'hg-theme-default myTheme1', // myTheme1
      sheet: false,
      sel_key: '',
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
   created() { //redirection
    //console.log(this.loggedIn);
    if (this.loggedIn) {
      this.$router.push('dashboard');
    }
  },
   methods: {
    handleLogin() {
      this.loading = true;
      /*this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          return;
        }*/
//this.user.username  && this.user.first_names && this.user.last_names
// this.user.username="superUser";
// this.user.email="superuser@ebenezer.com";
        if ( this.user.password && this.user.email) {
          this.$store.dispatch('auth/login', this.user).then(
            async response => {
              this.loading = false;              
              EventBus.$emit('sidebar_render', true);
              
              // Esperar un poco para que los permisos se carguen completamente
              console.log('✅ Login exitoso, esperando carga de permisos...');
              await new Promise(resolve => setTimeout(resolve, 500));
              
              this.$router.push('dashboard');   
              console.log('🚀 Redirigiendo al dashboard después del login');
              // console.log('login', response)           
            },
            error => {
              console.log('login error', error)
              let msj = 'Error login';
              if (error && error.response) {
                if (error.response.data && error.response.data.error) {
                  msj = error.response.data.error;
                }
              }else if(error && error.error){
                msj = error.error;
              }
              this.loading = false;

              this.message =  msj;// error.message /error.response.data.error || error.response.data.errors[0].password;//this.$ml.get("login_error");
                // (error.response && error.response.data) ||
                // error.message ||
                // error.toString();
                const timer = setTimeout(()=>{
                  this.message = '';
                  clearTimeout(timer);
                }, 8000)
              

            }
          );
        }
      // });
    },
    forgot(){
      this.loading = true;
      const api    = this.$URL + '/api/v1/auth/forgotpassword';
      axios.post(api, {email:this.email}).then(
        response => {
          this.loading  = false;
          // this.snackbar = true;
          // this.info     = this.$ml.get('save');
          // this.color    = "success";
          this.dialog   = false;
            this.$EventBus.$emit("notifications_modal",{
            type    : "success",
            message : this.$ml.get("ms_sp"), 
          })
          this.$router.push('security_psw');
        }).catch( error => {
          this.loading  = false;
     /*     this.snackbar = true;
          this.info     = this.$ml.get('error');
          this.color    = "error";*/
          this.dialog   = false;
          this.$EventBus.$emit("notifications_modal",{
            type    : "error",
            message : error, 
          });
        })
    }, //forgot

    onChange(input) {
      this.input     = input;
      let key        = this.sel_key;
      this.user[key] = input;
      // console.log(input, 'keys', key, this.input)

    },
    onKeyPress(button) {
      // console.log("button", button);
      if (button == '{enter}') {
        this.handleLogin();
      }
    },
    onInputChange(input) {
      this.input = input.target.value;
      // this.search=input;

    },
    keyboard_is_active(key){
      this.sel_key  = key;
      let key_board = false;
      if (localStorage.getItem('virtual_Key_board')) {
      key_board     = JSON.parse(localStorage.getItem('virtual_Key_board'));
    }
    
      if (key_board == true) {        
        this.sheet = true;
      }

      // console.log(key_board, this.sheet, 'activate key_board')
    },  
  }, // methods
  
  mounted(){    
    if (location && location.hostname.includes("demo")) {
      this.user.email     = "demo@demo.com";
      this.user.password  = "demo1234";
    }
  }, // mounted
};
</script>
